import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { App } from '@galaxy/marketplace-apps';
import { Package } from '@vendasta/marketplace-packages';
import { Revenue } from '@vendasta/sales-orders';
import { Observable, of } from 'rxjs';
import { AppSelectorComponent } from './app-selector/app-selector.component';
import { ItemSelectorAdapterComponent } from './item-selector-adapter/item-selector-adapter.component';
import { PackageSelectorComponent } from './package-selector/package-selector.component';
import { ItemSelectorFilterType } from '@galaxy/inventory-ui';

// This can also hold wholesale information if wholesalePricing is true
export class AppWithRetailPricing extends App {
  retailPricing: {
    currencyCode: string;
    revenue: Revenue;
  };
}

@Component({
  selector: 'sales-ui-sales-order-line-item-selector',
  templateUrl: './sales-order-line-item-selector.component.html',
  styleUrls: ['./sales-order-line-item-selector.component.scss'],
})
export class SalesOrderLineItemSelectorComponent implements OnInit {
  @Input() partnerId: string;
  @Input() marketId: string;
  @Input() preselectedPackages: Package[] = [];
  @Input() preselectedApps: App[] = [];
  @Input() hideSellingStandaloneProducts: boolean;
  @Input() hidePackages: boolean;
  @Input() hideOwnerName: boolean;
  @Input() hideOrderFormProducts: boolean;
  @Input() wholesalePricing: boolean;
  @Input() itemSelectorIncludesPackages: boolean;

  @ViewChild('apps') app: AppSelectorComponent;
  @ViewChild('itemSelectorAdapter') itemSelectorAdapter: ItemSelectorAdapterComponent;
  @ViewChild('packages') package: PackageSelectorComponent;

  itemTypesAvailable: ItemSelectorFilterType[] = ['products'];

  ngOnInit(): void {
    if (this.itemSelectorIncludesPackages) {
      this.itemTypesAvailable.push('packages');
    }
    if (this.hidePackages) {
      this.itemTypesAvailable = this.itemTypesAvailable.filter((itemType) => itemType !== 'packages');
    }
    if (this.hideSellingStandaloneProducts) {
      this.itemTypesAvailable = this.itemTypesAvailable.filter((itemType) => itemType !== 'products');
    }
  }

  getSelectedAppsWithRetailPricing(): Observable<AppWithRetailPricing[]> {
    if (this.hideSellingStandaloneProducts) {
      return of([]);
    }
    return this.itemSelectorAdapter.getAppsWithRetailPricing();
  }

  getSelectedPackages(): Observable<Package[]> {
    return this.itemSelectorIncludesPackages
      ? this.itemSelectorAdapter.getMarketplacePackages()
      : of(this.package?.getSelectedRows());
  }
}
